<template>
  <div>
    <video ref="videoPlayer" controls></video>
  </div>
</template>

<script>
  import Plyr from 'plyr';

  export default {
    name: "VideoPlayer",

    props: {
      options: {
        type: Object,
        default() {
          return {};
        }
      },
      onPlaying: {
        type: Function,
        default: () => {}
      },
      onPaused: {
        type: Function,
        default: () => {}
      },
      onBuffer: {
        type: Function,
        default: () => {}
      },
      onEnded: {
        type: Function,
        default: () => {}
      },
    },

    data() {
      return {
        player: null
      }
    },

    mounted() {
      this.player = new Plyr(this.$refs.videoPlayer, {
        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
      });
      this.player.source = {
        type: 'video',
        sources: this.options.sources,
      }

      this.player.on("playing", event => {
        this.onPlaying(event, event.detail.plyr.duration);
      });

      this.player.on("pause", event => {
        this.onPaused(event, event.detail.plyr.duration);
      });

      this.player.on("seeked", event => {
        this.onBuffer(event, event.detail.plyr.duration);
      });

      this.player.on("ended", event => {
        this.onEnded(event, event.detail.plyr.duration);
      });
    },
  }
</script>
